import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import { REGEX_PATTERNS } from "@/constants/RegexPatterns";
import useFeaturesData from "@/composables/featuresData";
import { CUSTOM_ICONS } from "@/constants/Unicode";

export default function getFeaturesHighwayData(detail, structure) {
  const configStore = useConfigStore();
  const inspectionStore = useInspectionStore();
  const { highwayCounty } = useFeaturesData();

  return {
    table: {
      headerRows: 0,
      widths: ["24%", "26%", "26%", "*"],
      body: [
        [
          { text: "F.02 On/Under: ", bold: true },
          {
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.ON_UNDER,
              inspectionStore.getFeatureIntersectionSelectedRow(detail?.rowId)?.onUnder,
            ),
          },
          {
            text: "RT.25 New Wear Surface Ind: ",
            bold: true,
          },
          {
            text: structure?.userInspection?.newWs == "1" ? CUSTOM_ICONS.SQUARE_CHECK : CUSTOM_ICONS.SQUARE,
            style: "customFontAwesome",
          },
        ],
        [
          { text: "B.F.03 Feature Name: ", bold: true },
          {
            text: detail?.roadwayName,
            alignment: "left",
          },
          { text: "B.H.14 Horiz (L): ", bold: true },
          {
            text: detail?.totHorClearLeft + " ft",
          },
        ],
        [
          { text: "RT.11 County: ", bold: true },
          {
            text: highwayCounty(detail),
          },
          { text: "B.H.15 Horiz (R): ", bold: true },
          {
            text: detail?.totHorClearRight + " ft",
          },
        ],
        [
          { text: "RT.12 State Route #: ", bold: true },
          {
            text: detail?.srNum,
            alignment: "left",
          },
          { text: "H.15 Min Vert (L): ", bold: true },
          {
            text: detail?.minOverVertClearLeft + " ft",
          },
        ],
        [
          { text: "RT.13 Segment: ", bold: true },
          {
            text: detail?.segNum,
            alignment: "left",
          },
          { text: "H.16 Min Vert (R): ", bold: true },
          {
            text: detail?.minOverVertClearRight + " ft",
          },
        ],
        [
          { text: "RT.14 Offset: ", bold: true },
          {
            text: detail?.OFFSET,
            alignment: "left",
          },
          { text: "H.17 Defense Vert (L): ", bold: true },
          {
            text: detail?.defVertClearLeft + " ft",
          },
        ],
        [
          { text: "B.RT.02 Route #: ", bold: true },
          {
            text: detail?.routeNum,
            alignment: "left",
          },
          { text: "H.18 Defense Vert (R): ", bold: true },
          {
            text: detail?.defVertClearRight + " ft",
          },
        ],
        [
          { text: "B.RT.03 Direction: ", bold: true },
          {
            text: detail?.routeDir,
          },
          { text: "F.03 Feature Type: ", bold: true },
          {
            text: detail?.featureType,
          },
        ],
        [
          { text: "B.H.01 Functional Class: ", bold: true },
          {
            text: detail?.funcClass,
          },
          { text: "H.19 Vert Clr Sign (L): ", bold: true },
          {
            text: detail?.vertClearSign,
          },
        ],
        [
          { text: "B.H.03 Nat Hwy Sys: ", bold: true },
          {
            text: detail?.nhsInd,
          },
          { text: "H.20 Vert Clr Posting (L): ", bold: true },
          {
            text:
              (Math.round(Number.parseFloat(detail?.vrtClrPostLeftFt)).toLocaleString() ?? "") +
              " ft" +
              "     " +
              (Math.round(Number.parseFloat(detail?.vrtClrPostLeftInch)).toLocaleString() ?? "") +
              " in",
          },
        ],
        [
          { text: "B.H.08 Lanes: ", bold: true },
          {
            text: detail?.lanes,
            alignment: "left",
          },
          { text: "H.21 Vert Clr Sign (R): ", bold: true },
          {
            text: configStore.getReferenceValue(REFERENCE_TABLE.VERTICAL_CLEARANCE_SIGN, detail?.VERT_CLEAR_SIGN_R),
          },
        ],
        [
          { text: "RT.02 Medians: ", bold: true },
          {
            text: detail?.numMedian,
            alignment: "left",
          },
          { text: "H.22 Vert Clr Posting (R): ", bold: true },
          {
            text:
              (Math.round(Number.parseFloat(detail?.vrtClrPostRightFt)).toLocaleString() ?? "") +
              " ft" +
              "     " +
              (Math.round(Number.parseFloat(detail?.vrtClrPostRightInch)).toLocaleString() ?? "") +
              " in",
          },
        ],
        [
          { text: "RT.03 Speed: ", bold: true },
          {
            colSpan: 3,
            text: detail?.roadSpeed + " mph",
          },
        ],
        [
          { text: "B.H.09 Recent ADT: ", bold: true },
          {
            colSpan: 3,
            text: detail?.adtTotal
              ?.toString()
              ?.replace(REGEX_PATTERNS.NUMBER_WITH_COMMAS.FIRST_HALF, REGEX_PATTERNS.NUMBER_WITH_COMMAS.SECOND_HALF),
            alignment: "left",
          },
        ],
        [
          { text: "B.H.11 Year: ", bold: true },
          {
            colSpan: 3,
            text: detail?.adtYear,
            alignment: "left",
          },
        ],
        [
          { text: "H.07 Truck % ADT: ", bold: true },
          {
            colSpan: 3,
            text: detail?.truckPct,
            alignment: "left",
          },
        ],
        [
          { text: "B.H.10 ADTT: ", bold: true },
          {
            colSpan: 3,
            text: detail?.adtt
              ?.toString()
              ?.replace(REGEX_PATTERNS.NUMBER_WITH_COMMAS.FIRST_HALF, REGEX_PATTERNS.NUMBER_WITH_COMMAS.SECOND_HALF),
            alignment: "left",
          },
        ],
        [
          { text: "H.08 ADTT Year: ", bold: true },
          {
            colSpan: 3,
            text: detail?.adttYear,
            alignment: "left",
          },
        ],
      ],
    },
    layout: {
      hLineWidth: function (i, node) {
        return i === 0 || i === node.table.body.length ? 2 : 0;
      },
      vLineWidth: function (i, node) {
        return i === 0 || i === node.table.widths.length ? 1 : 0;
      },
      hLineColor: function () {
        return "black";
      },
      vLineColor: function () {
        return "gray";
      },
    },
    unbreakable: true,
    margin: [10, 0, 10, 0],
  };
}
